import { useQuery } from '@tanstack/react-query';

import { AxiosError, AxiosResponse } from 'axios';

import { api } from '@/api';

export interface PopupItem {
	popup_pk: number;
	popup_name: string;
	popup_image: string;
	popup_url: string;
	popup_exposure_location: string | null;
	popup_enrollment_date: string;
	popup_update_date: string | null;
}

interface PopupResponseData {
	popup: PopupItem[];
}

export const useGetPopupApi = () => {
	const url = '/front/getPopup';
	return useQuery<AxiosResponse, AxiosError, PopupResponseData>({
		queryKey: [url],
		queryFn: () => api.get(url),
		select: (res) => res.data.data,
	});
};
